<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="dedication"></a><a id="page_v"></a>To my wife, Christina,<br/>for her encouragement of this particular bastard<br/>and for not imposing term limits<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?37e8f6e8